/* 退出登录 */
import { _DELETE } from '@/packge/http';
import { PLAT_TYPE } from '@/utils/constant';
import Common, { isMobilePlatform, getPlatFormType } from '@/utils/common';
import { message } from 'ant-design-vue';
import router from '@/router';
import Qs from 'qs';
import wx from 'weixin-js-sdk';

function signOutApp () {
  const PlatForm = sessionStorage.getItem('PlatFormType');
  if (PlatForm == 1) {
    const appType = sessionStorage.getItem('appType');
    let url;
    if (appType == 1) {
      url = '/pages/login';
      wx.miniProgram.redirectTo({
        url
      });
      return;
    }

    let platFormType = getPlatFormType();
    if (platFormType == 'android') {
      try {
        window.android.logout();
      } catch (err) {}
    } else if (platFormType == 'ios') {
      try {
        window.webkit.messageHandlers.logout.postMessage(null);
      } catch (err) {}
    }
  } else if (PlatForm == 2) {
    // applyType
    // 1社区小程序 3管家通小程序 /pages/login
    // 2工程

    const applyType = sessionStorage.getItem('applyType');
    let url;
    if (applyType == 1 ) {
      url = '/pages/login';
    }else if(applyType == 3){
      url = '/pages/loginInfo/login';
    }
     else {
      url = '/pages/login/loginPassword';
    }
    wx.miniProgram.redirectTo({
      url
    });
    // wx.miniProgram.postMessage({data: {type: 'outLogin'}});
  }
}
function clearToken () {
  Common.removeToken();
  localStorage.clear();
  sessionStorage.clear();
}
export function logOut () {
  return new Promise(resolve => {
    _DELETE({
      url: '/userLogin/logout',
      params: { platType: PLAT_TYPE }
    }).then(() => {
      if (isMobilePlatform()) {
        signOutApp();
        clearToken();
        setTimeout(() => {
          router.push({ name: 'mobileLogin' });
        }, 0);
      } else {
        if (location.search.includes('code')) { // 去掉code search
          clearToken();
          setTimeout(() => {
            router.push('/login');
          }, 0);
        } else {
          clearToken();
          setTimeout(() => {
            let searchObj = Qs.parse(location.search, { ignoreQueryPrefix: true });
            router.push({ name: 'login', query: searchObj });
          }, 0);
        }
      }
      message.success('退出成功！');
      resolve();
    });
  });
}

export function MobileLogOut () {
  return new Promise(resolve => {
    _DELETE({
      url: '/userLogin/logout',
      params: { platType: PLAT_TYPE }
    }).then(() => {
      signOutApp();
      resolve();
      setTimeout(() => {
        Common.removeToken();
        localStorage.clear();
        sessionStorage.clear();
        router.push({ name: 'mobileLogin' });
        message.success('退出成功！');
      }, 0);
    });
  });
}
